<template>
  <form v-on:submit.prevent="click" v-if="microtag">

    <div class="row">
      <div class="col-md-12">
        <!-- Custom Tabs -->
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#tab_1" data-toggle="tab">Generali</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="tab_1">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nome">Nome</label>
                        <input type="text" class="form-control" id="nome"
                               name="nome"
                               v-model="microtag.microtag" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="macrotag">Macrotag</label>
                        <multiselect
                          v-model="microtag.macrotag"
                          :options="macrotags"
                          track-by="id"
                          label="macrotag"
                          placeholder="seleziona"
                          SelectLabel="seleziona"
                          SelectedLabel="selezionato"
                          DeselectLabel="deseleziona"
                          id="macrotag"
                          name="macrotag"
                          :clear-on-select="false"
                          :searchable="true"
                          @search-change="macrotagsFind">
                        </multiselect>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.tab-pane -->

          </div>
          <!-- /.tab-content -->

          <div class="box-footer">
            <div class="row">
              <div class="col-md-2 col-md-offset-10">
                <button class="btn btn-success btn-block" v-if="!disabled">
                  <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                  Salva
                </button>

                <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                        v-if="disabled">
                  Attiva modifiche
                </button>
              </div>
            </div>
          </div>

        </div>
        <!-- nav-tabs-custom -->
      </div>
    </div>

  </form>
</template>

<script>
  import {clientDateFormat} from '@/filters'
  import microtagsApi from '../../api/microtags'
  import macrotagsApi from '@/api/macrotags'
  import Multiselect from 'vue-multiselect'

  export default {
    props: ['disabled', 'microtag', 'loader', 'showLabels'],
    methods: {
      click () {
        if (this.microtag.macrotag === undefined) {
          toastr.error('Devi inserire il macrotag padre')
          return
        }
        this.$emit('click', this.microtag)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.microtag)
      },
      macrotagsFind (query) {
        macrotagsApi.select(query)
          .then((response) => {
            this.macrotags = response.data.data
          })
      }
    },
    data () {
      return {
        config: {
          format: clientDateFormat
        },
        macrotags: [],
        microtags: []
      }
    },
    computed: {
      donazione_tipi () {
        return this.$store.state.decoder.decoders['_dDonationTypes']
      }
    },
    beforeCreate () {
      microtagsApi.index()
        .then((response) => {
          this.microtags = response.data.data
        })
    },
    components: {
      Multiselect
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/microtags/Form.vue